<template>
	<div class="header pt-1" id="home">
		<div class="container">
			<!-- هدر وقتی وارد شده باشد -->
			<ul class="dir-rtl mt-2" v-if="signHeaderFlag == false">
				<li style="vertical-align: bottom;width:50% !important">
					<div id="sideMenuTempSign" @click="goAccountPage">
						<div class="humber"></div>
						<div class="humber"></div>
						<div class="humber"></div>
					</div>
					<!-- <i class ="fa fa-times" id="closeIcon" style="display:none" @click="closeSidePopup"></i> -->
				</li>
				<li class=" my-brand" style="width:50% !important">
					<h2 class="text-end">RADAP</h2>
				</li>
				<li style="width:33% !important">
					<button class="no-effect-button align-center " type="button" data-bs-toggle="modal"
						data-bs-target="#StoreModal" style="font-size: 15px;">
						<span>{{ city }}</span>
						<i class="fa fa-angle-down" aria-hidden="true" style="vertical-align: middle;"></i>
					</button>
				</li>
				<li class="header-li header-score text-center" style="width:33% !important;font-weight: 600;font-size: 14px;" @click="goScoreAccount" >
					<Transition>
						<span v-if="show">
							<i :class="profile.score.icon" aria-hidden="true"></i>
							{{ PersianNumber(profile.score.value) }}
						</span>
					</Transition>
					<span v-if="!show">
						<i :class="profile.score.icon" aria-hidden="true"></i>
						{{ PersianNumber(profile.score.value) }}
					</span>
				</li>

				<li style="width:33% !important;text-align: end;" @click="goWalletAccount">
					<button  :disabled="profile.wallet.disabled">
						<i :class="profile.wallet.icon" aria-hidden="true"></i> {{ PersianNumber(numberFormat(profile.wallet.value)) }}
					</button>
				</li>
			</ul>
			<!-- هدر وقتی وارد نشده باشد -->
			<ul class="dir-rtl py-2" v-else>
				<li style="vertical-align: bottom;" class="header-mobile-none">
					<div @click="getSideMenu()" id="sideMenuTemp">
						<div class="humber"></div>
						<div class="humber"></div>
						<div class="humber"></div>
					</div>
				</li>
				<li class="header-mobile-none my-brand">
					<h2 class="text-center">RADAP</h2>
				</li>
				<li class="text-end header-mobile-none sign-info">
					<button><span @click="goAccountPage(1)">ورود</span>|<span @click="goAccountPage(2)">ثبت نام</span></button>
				</li>
			</ul>
		</div>
	</div>
	<!-- <button type="button" class="btn-close d-none" data-bs-dismiss="modal" id="sideMenuModalCloseBTN"></button> -->
</template>

<script setup>
import { reactive, ref } from '@vue/reactivity'
import { useRouter } from 'vue-router';
import { removeCommos,numberFormat } from '@/composables/digits';
import axios from 'axios'
let updateUserInfo = ref()
let city = ref()
let myLog = ref(false)
let signHeaderFlag = ref(false)
let show = ref(false)
let router = useRouter()
let profile = reactive({
	avatar: { value: 'ورود', icon: 'fa fa-unlock-alt', disabled: false },
	wallet: { value: 'عضویت', icon: 'fa fa-pencil-square-o', disabled: false },
	score: { value: '05152524850', icon: 'fa fa-phone' },
	location: { value: 'info.radap', icon: 'fa fa-envelope-o' },
	signIn: ''
})
validSignIn()
getCity()
updateUser()
setInterval(() => { updateUser() }, 60000);

function validSignIn() {
	profile.signIn = getLocalStorage();
	if (profile.signIn) {
		profile.signIn = JSON.parse(profile.signIn)
		setProfileInfo()
	} else {
		signHeaderFlag.value = true;
	}
}
function getLocalStorage() {
	return localStorage.getItem('userInfo');
}
function updateUser() {
	if (!signHeaderFlag.value) {
		axios.get('https://radap.ir/Backend/api/section/follow/updateUser_new.php?username=' + profile.signIn[0].mobile)
			.then((res) => {
				addLocalStorage(res.data)
				validSignIn()
			})
	}
}
function addLocalStorage(information) {
	if (information.score != Number(profile.score.value.replace('امتیاز', ''))) {
		show.value = !show.value
	}
	updateUserInfo.value = [];
	updateUserInfo.value.push({
		id: information.id,
		name: information.name,
		family: information.family,
		mobile: information.mobile,
		wallet: information.wallets,
		score: information.score,
		location: information.location,
		location2: information.location2,
		location3: information.location3,
		born: information.born,
		nid: information.nid,
		sheba: information.sheba,
		gender: information.gender,
		email: information.email,
		token: information.token,
		password: information.password
	})
	localStorage.setItem('userInfo', JSON.stringify(updateUserInfo.value));
}
function setProfileInfo() {
	profile.avatar.value = profile.signIn[0].name + ' ' + profile.signIn[0].family;
	profile.avatar.icon = 'fa fa-user';
	profile.avatar.disabled = true;

	profile.wallet.value = 0;
	// profile.wallet.value = profile.signIn[0].wallet;
	for(let i in profile.signIn[0]['wallet']){
		if(profile.signIn[0]['wallet'][i].amount){
				profile.wallet.value += Number(removeCommos(profile.signIn[0]['wallet'][i].amount))
		}
	}
	profile.wallet.icon = 'fa fa-credit-card';
	profile.wallet.disabled = false;

	profile.score.value = profile.signIn[0].score + ' امتیاز';
	profile.score.icon = 'fa fa-certificate';
	
	if (profile.signIn[0].location != '' && profile.signIn[0].location != ' ') {
		profile.location.value = profile.signIn[0].location;
	} else if (profile.signIn[0].location2 != '' && profile.signIn[0].location2 != ' ') {
		profile.location.value = profile.signIn[0].location2;
	} else if (profile.signIn[0].location3 != '' && profile.signIn[0].location3 != ' ') {
		profile.location.value = profile.signIn[0].location3;
	} else {
		profile.location.value = 'لطفا آدرستان را تعیین نمایید.';
	}
	profile.location.icon = 'fa fa-map-marker';
}
function goAccountPage(type) {
	if (profile.avatar.disabled !== false) {
		getSideMenu()
	} else {
		myLog.value = true
		if (type == 1) {
			document.querySelector('#loginsModalBTN').click()
		} else {
			document.querySelector('#mobileModalBTN').click()
		}
	}
}
function getSideMenu() {
	document.querySelector('#sideMenuModalBTN').click()
}
function PersianNumber(t) {
	for (t = t.toString(); t.search("0") > -1;)t = t.replace("0", "۰"); for (; t.search("1") > -1;)t = t.replace("1", "۱"); for (; t.search("2") > -1;)t = t.replace("2", "۲"); for (; t.search("3") > -1;)t = t.replace("3", "۳"); for (; t.search("4") > -1;)t = t.replace("4", "۴"); for (; t.search("5") > -1;)t = t.replace("5", "۵"); for (; t.search("6") > -1;)t = t.replace("6", "۶"); for (; t.search("7") > -1;)t = t.replace("7", "۷"); for (; t.search("8") > -1;)t = t.replace("8", "۸"); for (; t.search("9") > -1;)t = t.replace("9", "۹"); return t
}
function getCity() {
	if (JSON.parse(localStorage.getItem('city')) !== null) {
		city.value = JSON.parse(localStorage.getItem('city'))[0]['cityFa']
	} else {
		city.value = 'تربت جام'
	}
}
function goWalletAccount(){
	router.push({name:'Account',hash:'#credit'})
}
function goScoreAccount(){
	router.push({name:'Account',hash:'#score'})
}

</script>
<style scoped>
.header ul li {
	text-align: start;
	width: 33%;
}

.header-li-brand {
	display: none;
}

@media (min-width: 644px) {
	.header-mobile {
		display: none !important;
	}
}

@media (min-width: 644px) {
	.header-mobile-none {
		width: 33% !important;
	}
}

.header-location {
	/* width: 100% !important; */
	white-space: nowrap;
	overflow: hidden;
	vertical-align: middle;
}

@media (max-width: 776px) {

	.header ul li {
		padding: 0;
		width: 33%;
	}

	/* .header-score{
		text-align: end !important;
	} */
	.header-basket {
		display: none;
	}

	.header-location i {
		margin-right: 0;
	}

	.header-mobile {
		display: inline-block !important;
	}

}

.my-brand h2 {
	color: red;
	font-size: 22px;
	font-family: 'Adera' !important;
	text-align: end;
	/* text-shadow: 3px 4px 4px;
	letter-spacing: 4px; */
}

.humber {
	width: 26px;
	height: 2px;
	background-color: #d5d5d5;
	margin: 5px 0;
}

.header {
	background: #fff;
}

.humber {
	background-color: black !important;
}

.user-info * {
	color: black !important;
}

.sign-info * {
	color: black !important;
}

.v-enter-active,
.v-leave-active {
	transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
}
</style>
